import "core-js/modules/es.array.index-of";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var LoginPageLayout = /*#__PURE__*/function (_Vue) {
  _inherits(LoginPageLayout, _Vue);

  var _super = _createSuper(LoginPageLayout);

  function LoginPageLayout() {
    var _this;

    _classCallCheck(this, LoginPageLayout);

    _this = _super.apply(this, arguments);
    _this.loginLogo = require('@/assets/images/login/login-logo.png');
    _this.brand1 = [require('@/assets/icons/brand1.svg')];
    _this.brand2 = [require('@/assets/icons/brand2.svg')];
    _this.brand3 = [require('@/assets/icons/brand3.svg')];
    _this.brand4 = [require('@/assets/icons/brand4.svg')];
    _this.brand5 = [require('@/assets/icons/brand5.svg')];
    return _this;
  }

  _createClass(LoginPageLayout, [{
    key: "goLogin",
    value: function goLogin() {
      this.$router.push({
        name: 'Login'
      });
    }
  }, {
    key: "brand",
    get: function get() {
      return [this.brand1, this.brand2, this.brand3, this.brand4, this.brand5];
    }
  }, {
    key: "isChrome",
    get: function get() {
      // console.log('浏览器判断', navigator.userAgent)
      // console.log('浏览器判断 Chrome 内核', navigator.userAgent.indexOf('Chrome') > -1)
      // console.log('浏览器判断 Mobile 模式', navigator.userAgent.indexOf('Mobile') > -1)
      return navigator.userAgent.indexOf('Chrome') > -1 && !(navigator.userAgent.indexOf('Mobile') > -1);
    }
  }]);

  return LoginPageLayout;
}(Vue);

__decorate([Prop({
  default: false
})], LoginPageLayout.prototype, "hasBackLogin", void 0);

LoginPageLayout = __decorate([Component], LoginPageLayout);
export default LoginPageLayout;